"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import i18n from "@/lang";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import ConfigEarlyLeftWarning from "@/views/safemanagements/InprogressManager/components/configEarlyWarningComponents/ConfigEarlyLeftWarning.vue";
import ConfigEarlyRightWarning from "@/views/safemanagements/InprogressManager/components/configEarlyWarningComponents/ConfigEarlyRightWarning.vue";
import { Debounce } from "vue-debounce-decorator";
export class ConfigEarlyWarningFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.early_warning_name = "";
    this.notice_way = "SEND_MESSAGE";
    this.notice_members = ["MAIN_ACCOUNT", "MANAGER"];
    this.target_members = [];
    this.target_shops = [];
    this.warning_description = "";
    // 系统配置编辑信息
    // 关联网页
    this.system_config_web_page = "";
    // 预览的gif图
    this.system_config_gif = "";
    // 最大触发条件条数
    this.system_config_trigger_max = 0;
    // 触发条件
    this.system_config_trigger_condition = [];
    // 处理措施
    this.handling_measures = false;
    // 处理配置
    this.handling_measures_type = "ALL_SUBACCOUNT";
    // 处理配置成员
    this.handling_measures_members = [];
    // 主要类型
    this.trigger_type = "";
    // 自定义配置或通用配置编辑信息
    this.trigger_condition_shops = [];
    this.trigger_condition_type = "ALL";
    this.config_trigger_condition = {
      "datas": []
    };
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("config_early_warning.form.early_warning_name_tip"),
      trigger: "blur"
    }
  ])
], ConfigEarlyWarningFormController.prototype, "early_warning_name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("config_early_warning.form.notice_way_tip"),
      trigger: "blur"
    }
  ])
], ConfigEarlyWarningFormController.prototype, "notice_way", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("config_early_warning.form.notice_members_placeholder"),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        if (value.length === 0) {
          callback(i18n.t("config_early_warning.form.notice_members_placeholder"));
          return false;
        }
        callback();
        return true;
      },
      trigger: "change"
    }
  ])
], ConfigEarlyWarningFormController.prototype, "notice_members", 2);
let ConfigEarlyWarning = class extends Vue {
  constructor() {
    super(...arguments);
    this.pageLoading = false;
    this.editMode = false;
    this.submitLoading = false;
    this.configEarlyWarningFormController = new ConfigEarlyWarningFormController();
    this.id = "";
    this.warningType = "config";
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query && this.$route.query.id) {
        this.editMode = true;
        this.id = this.$route.query.id;
        yield this.getEditWarningInfo();
      } else {
        this.editMode = false;
      }
    });
  }
  getEditWarningInfo() {
    return __async(this, null, function* () {
      try {
        this.pageLoading = true;
        const response = yield API.get(`api://base.auth/api/v1/monitor/alarm/internal-events/${this.id}/settings/detail`);
        if (response.data.dataType === "SYSTEM") {
          this.warningType = "system";
        } else {
          this.warningType = "config";
        }
        this.configEarlyWarningFormController.early_warning_name = response.data.eventName;
        this.configEarlyWarningFormController.notice_way = response.data.notifyTypes;
        this.configEarlyWarningFormController.notice_members = response.data.recipientTypes;
        this.configEarlyWarningFormController.warning_description = response.data.eventDesc;
        this.configEarlyWarningFormController.system_config_web_page = response.data.relatedWebpageUrl;
        this.configEarlyWarningFormController.system_config_trigger_max = 5;
        this.configEarlyWarningFormController.system_config_gif = response.data.alarmPreviewUrl;
        this.configEarlyWarningFormController.trigger_type = response.data.triggerType;
        this.configEarlyWarningFormController.handling_measures_type = response.data.affectMemberType;
        this.configEarlyWarningFormController.handling_measures_members = response.data.affectMembers;
        this.configEarlyWarningFormController.system_config_trigger_condition = response.data.triggersSettings;
        if (response.data.triggerType === "General_In_Monitor_Page") {
          this.configEarlyWarningFormController.trigger_condition_type = response.data.triggersSettings[0].shopRange;
          this.configEarlyWarningFormController.trigger_condition_shops = response.data.triggersSettings[0].shops;
        }
        if (response.data.triggerType === "Amazon_Price_Too_Low" || response.data.triggerType === "Amazon_Percentage_Off_Too_High" || response.data.triggerType === "Amazon_Coupon_Too_High") {
          this.configEarlyWarningFormController.handling_measures = response.data.forbiddenSubmitOrSave;
        }
        if (response.data.triggerType === "Amazon_Goods_Caption_Edit_Too_Frequently" || response.data.triggerType === "Amazon_Main_Image_Adjusted_Too_Frequently") {
          this.configEarlyWarningFormController.handling_measures = response.data.forbiddenSubmitOrSave;
        }
        if (response.data.dataType !== "SYSTEM") {
          this.configEarlyWarningFormController.trigger_condition_type = response.data.triggersSettings[0].shopRange;
          this.configEarlyWarningFormController.trigger_condition_shops = response.data.triggersSettings[0].shops;
          this.configEarlyWarningFormController.config_trigger_condition = response.data.triggersSettings[0].triggerCondition;
          for (let item of this.configEarlyWarningFormController.config_trigger_condition.datas) {
            item.name = item.webElementResource.name;
            item.url = item.webElementResource.url;
            if (!item.webElementResourceElements) {
              item.webElementResourceElements = [];
            }
            if (!item.webElementResourceElementIds) {
              item.webElementResourceElementIds = [];
            }
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.pageLoading = false;
      }
    });
  }
  submitForm() {
    return __async(this, null, function* () {
      try {
        yield this._configEarlyWarningForm._form.validate();
        let submitData = {};
        submitData.notifyType = this.configEarlyWarningFormController.notice_way;
        submitData.recipientTypes = this.configEarlyWarningFormController.notice_members;
        submitData.notifyUserids = [];
        submitData.affectMemberType = this.configEarlyWarningFormController.handling_measures_type;
        let members_ids = [];
        this.configEarlyWarningFormController.handling_measures_members.forEach((item) => {
          members_ids.push(item.id);
        });
        submitData.affectMembers = members_ids;
        if (!this.editMode) {
          if (this.warningType === "config") {
            if (!this.configEarlyWarningFormController.config_trigger_condition.datas || this.configEarlyWarningFormController.config_trigger_condition.datas && this.configEarlyWarningFormController.config_trigger_condition.datas.length === 0) {
              this.$message.error(i18n.t("config_early_warning.form.config_empty"));
              return;
            }
            let flag = false;
            for (let item of this.configEarlyWarningFormController.config_trigger_condition.datas) {
              if (!item.events["VISIT_PAGE"] && !item.events["COPY_EVENT"] && !item.events["UPLOAD_FILE_EVENT"] && !item.events["DOWNLOAD_FILE_EVENT"] && !item.events["PRINT_EVENT"] && !item.events["OPEN_DEV_MODE_EVENT"] && !item.events["CLICK_ELEMENT"]) {
                flag = true;
                break;
              }
              if (item.events["CLICK_ELEMENT"] && (!item.webElementResourceElementIds || item.webElementResourceElementIds && item.webElementResourceElementIds.length === 0)) {
                flag = true;
                break;
              }
            }
            if (flag) {
              return;
            }
            submitData.eventName = this.configEarlyWarningFormController.early_warning_name;
            submitData.eventDesc = this.configEarlyWarningFormController.warning_description;
            let shopIds = [];
            this.configEarlyWarningFormController.trigger_condition_shops.forEach((item) => {
              shopIds.push(item.id);
            });
            let settingData = [];
            let data = {
              "triggerCondition": this.configEarlyWarningFormController.config_trigger_condition,
              "shopRange": this.configEarlyWarningFormController.trigger_condition_type,
              "shopIds": shopIds
            };
            settingData.push(data);
            submitData.triggersSettings = settingData;
            yield API.post(`api://base.auth/api/v1/monitor/alarm/custom-events/settings`, submitData);
            this.$message.success(i18n.t("config_early_warning.config_submit_success"));
          }
        }
        if (this.editMode) {
          if (this.warningType === "system") {
            if (this.configEarlyWarningFormController.trigger_type === "General_In_Monitor_Page") {
              submitData.triggersSettings = this.configEarlyWarningFormController.system_config_trigger_condition;
              submitData.triggersSettings[0].shopRange = this.configEarlyWarningFormController.trigger_condition_type;
              let shopIds = [];
              this.configEarlyWarningFormController.trigger_condition_shops.forEach((item) => {
                shopIds.push(item.id);
              });
              submitData.triggersSettings[0].shopIds = shopIds;
            }
            if (this.configEarlyWarningFormController.trigger_type === "Amazon_Price_Too_Low" || this.configEarlyWarningFormController.trigger_type === "Amazon_Percentage_Off_Too_High" || this.configEarlyWarningFormController.trigger_type === "Amazon_Coupon_Too_High") {
              let extraData = this.configEarlyWarningFormController.system_config_trigger_condition;
              extraData.forEach((item) => {
                if (item.shopRange === "SPECIFIED") {
                  let shopIds = [];
                  item.shops.forEach((shop) => {
                    shopIds.push(shop.id);
                  });
                  item.shopIds = shopIds;
                }
                if (item.shopRange === "ALL") {
                  item.shopIds = [];
                }
              });
              submitData.triggersSettings = extraData;
              submitData.forbiddenSubmitOrSave = this.configEarlyWarningFormController.handling_measures;
            }
            if (this.configEarlyWarningFormController.trigger_type === "Amazon_Goods_Caption_Edit_Too_Frequently" || this.configEarlyWarningFormController.trigger_type === "Amazon_Main_Image_Adjusted_Too_Frequently") {
              let extraData = this.configEarlyWarningFormController.system_config_trigger_condition;
              extraData.forEach((item) => {
                if (item.shopRange === "SPECIFIED") {
                  let shopIds = [];
                  item.shops.forEach((shop) => {
                    shopIds.push(shop.id);
                  });
                  item.shopIds = shopIds;
                }
                if (item.shopRange === "ALL") {
                  item.shopIds = [];
                }
              });
              submitData.triggersSettings = extraData;
              submitData.forbiddenSubmitOrSave = this.configEarlyWarningFormController.handling_measures;
            }
            yield API.put(`api://base.auth/api/v1/monitor/alarm/internal-events/${this.id}/settings`, submitData);
            this.$message.success(i18n.t("config_early_warning.submit_success"));
          }
          if (this.warningType === "config") {
            let flag = false;
            for (let item of this.configEarlyWarningFormController.config_trigger_condition.datas) {
              if (!item.events["VISIT_PAGE"] && !item.events["COPY_EVENT"] && !item.events["UPLOAD_FILE_EVENT"] && !item.events["DOWNLOAD_FILE_EVENT"] && !item.events["PRINT_EVENT"] && !item.events["OPEN_DEV_MODE_EVENT"] && !item.events["CLICK_ELEMENT"]) {
                flag = true;
                break;
              }
              if (item.events["CLICK_ELEMENT"] && (!item.webElementResourceElementIds || item.webElementResourceElementIds && item.webElementResourceElementIds.length === 0)) {
                flag = true;
                break;
              }
            }
            if (flag) {
              return;
            }
            submitData.eventName = this.configEarlyWarningFormController.early_warning_name;
            submitData.eventDesc = this.configEarlyWarningFormController.warning_description;
            let shopIds = [];
            this.configEarlyWarningFormController.trigger_condition_shops.forEach((item) => {
              shopIds.push(item.id);
            });
            let settingData = [];
            let data = {
              "triggerCondition": this.configEarlyWarningFormController.config_trigger_condition,
              "shopRange": this.configEarlyWarningFormController.trigger_condition_type,
              "shopIds": shopIds
            };
            settingData.push(data);
            submitData.triggersSettings = settingData;
            yield API.put(`api://base.auth/api/v1/monitor/alarm/custom-events/${this.id}/settings`, submitData);
            this.$message.success(i18n.t("config_early_warning.submit_success"));
          }
        }
        this.$router.push("/midsafety?tab=early_warning");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.push("/midsafety?tab=early_warning");
  }
  helpButton() {
  }
};
__decorateClass([
  Ref("configEarlyWarningForm")
], ConfigEarlyWarning.prototype, "_configEarlyWarningForm", 2);
__decorateClass([
  Debounce(400)
], ConfigEarlyWarning.prototype, "submitForm", 1);
ConfigEarlyWarning = __decorateClass([
  Component({
    components: {
      UiForm,
      ConfigEarlyLeftWarning,
      ConfigEarlyRightWarning
    }
  })
], ConfigEarlyWarning);
export {
  ConfigEarlyWarning as default
};
